/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import Config from "data/config";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";

const ScaledWidthImage = (props) => {
    
    const enableImageDebug = Config.Debug.enableDiagnostics;
    const { image, settings } = props || {};
    const { width, height } = image || {};
    const { options } = settings || {};
    const {
        dimension = "100%",
        forceSixteenNine = true,
        contain= false
    } = options || {};
    const hasWidth = !!width;
    const hasHeight = !!height;
    let aspect_ratio, fit, maxWidth, backgroundColor;
    if (forceSixteenNine) {
        fit = "contain";
        maxWidth = "100%";
        aspect_ratio = "16/9";
        backgroundColor = "#f0f0f0";
    } else if (contain) {
        fit = "contain";
        maxWidth = "100%";
    } else if (hasWidth && hasHeight) {
        const longerSide = height >= width ? "height" : "width";
        aspect_ratio = (longerSide === "height") ? `${height}/${width}` : `${width}/${height}`;
    }
    
    const message = "No image to display";
    const component = { type: "component.image" };
    
    return (
        <>
            {image ? (
                <>
                    {enableImageDebug &&
                        <h6>Width Priority Image (width: {dimension})</h6>
                    }
                    <img
                        src={image.url}
                        alt={image.alt}
                        width={dimension}
                        style={{
                            aspectRatio: aspect_ratio,
                            objectFit: fit,
                            maxWidth: maxWidth,
                            backgroundColor
                        }}
                    />
                </>
            ) : (
                <>
                    <EmptyContentMessage
                        hasContent={!image}
                        message={message}
                        component={component}
                    />
                </>
            )}
        </>
    );
};

export default ScaledWidthImage;
